import React from 'react';
import IconBoxStyle11 from '../../IconBox/IconBoxStyle11';
import Spacing from '../../Spacing';

export default function ContactInfoSection({ sectionTitle }) {
  return (
    <div className="container">
      <h2 className="cs_fs_72 mb-0">{sectionTitle}</h2>
      <Spacing md="70" lg="50" />
      <div className="row g-4 g-xl-3 g-xxl-5">
        <div className="col-xl-4 col-md-6 col-12" style={{ display: 'flex' }}>
          <IconBoxStyle11
            title="Phone"
            subTitle="+971507098504"
            iconSrc={process.env.PUBLIC_URL + "/images/contact/icon_1.svg"}
            iconColor="lightYellow"
            textColor="#ffffff"
          />
        </div>
        <div className="col-xl-4 col-md-6 col-12" style={{ display: 'flex' }}>
          <IconBoxStyle11
            title="Email"
            subTitle="sales@mednadatasystems.com"
            iconSrc={process.env.PUBLIC_URL + "/images/contact/icon_2.svg"}
            iconColor="lightYellow"
            textColor="#ffffff"
          />
        </div>
        <div className="col-xl-4 col-md-12 col-12" style={{ display: 'flex' }}>
          <IconBoxStyle11
            title="Location"
            subTitle="IFZA Business Park, Dubai Silicon Oasis"
            iconSrc={process.env.PUBLIC_URL + "/images/contact/icon_3.svg"}
            iconColor="lightYellow"
            textColor="#ffffff"
          />
        </div>
      </div>
      <Spacing md="35" />
      {/* Start Google Map */}
      {/* <div className="cs_map">
        <iframe
          id="map"
          title="Google Map"
          src="https://maps.app.goo.gl/A8hpCzcWUoLdn9vo6"
          allowFullScreen
        />
      </div> */}
      {/* End Google Map */}
    </div>
  );
}
